<span *ngIf="!updating && product?.availability && availability"
  class="stock-indicator {{ 'availability' + availability.availability.toString() }}" [class.tooltip]="!hasDate()"
  [class.tooltip-left]="!hasDate()"
  [attr.data-tooltip]="!hasDate() ? (availability.text ? availability.text : 'product.availability' + availability.availability.toString() | translate) : null">

  <div *ngIf="hasDate()" class="custom-tooltip-box">
    <div class="custom-tooltip-main">{{ availability.text }} <sup>1</sup></div>
    <div class="custom-tooltip-warning">{{ 'product.availabilityInfoNonContractual' | translate }}</div>
  </div>
</span>

<div class="stock-indicator-unavailability"
  *ngIf="product?.unavailabilityInfo && availability && product?.unavailabilityInfo.reason == 'Nouveauté à venir'"
  [innerHTML]="product?.unavailabilityInfo.reason">
</div>

<!-- <div class="stock-indicator-unavailability"
  *ngIf="product?.unavailabilityInfo && product?.unavailabilityInfo.reason == 'Organisationnel'"
  [innerHTML]="product?.unavailabilityInfo.reason" >
</div> -->